module.exports = __webpack_public_path__ + "img/mac-hero.ad226ded.webp";